<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="card-checklist" class="icon"></b-icon>
            <span>รายการบริการอื่นๆ</span>
        </div>

        <div class="content">
            <div class="filter form mb-4">
                <store-service-filter @lookup="filterStoreServiceList($event)"></store-service-filter>
            </div>

            <div class="mb-4 text-right">
                <button class="btn btn-main" @click="openStoreServiceForm('')">เพิ่มบริการของร้านค้า</button>
            </div>

            <perfect-scrollbar>
                <table>
                    <thead>
                        <tr>
                            <th class="action-column"></th>
                            <th>บริการ</th>
                            <th>ราคา</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in storeServiceList" :key="index">
                            <td class="text-center text-nowrap">
                                <button class="icon" @click="openStoreServiceForm(item.key)"><b-icon icon="pencil"></b-icon></button>
                                <button class="icon" @click="deleteStoreService(item.data)"><b-icon icon="trash"></b-icon></button>
                            </td>
                            <td>{{ item.serviceTopic }}</td>
                            <td>{{ item.price }}</td>
                        </tr>
                    </tbody>
                </table>
            </perfect-scrollbar>

            <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

            <div class="no-data" v-if="storeServiceList.length === 0 && !isLoading">
                <b-icon icon="exclamation-diamond"></b-icon>
                <span>ไม่พบรายการบริการ</span>
            </div>
        </div>

        <store-service-modal-form :isDisplay="isShowStoreServiceForm" :keyData="storeServiceKeyId" @hide="closeStoreServiceForm($event)"></store-service-modal-form>
    </div>
</template>

<script>
import StoreServiceFilter from '@/components/storeService/Filter';
import StoreServiceModalForm from '@/components/storeService/ModalForm';
import Helper from '@/resources/Helper';
import DBStoreService from '@/database/StoreService';
import ModelKeywordFilter from '@/resources/models/KeywordFilter';

export default {
    components: {
        StoreServiceFilter,
        StoreServiceModalForm
    },
    data() {
        return {
            isShowStoreServiceForm: false,
            storeServiceKeyId: '',
            storeServiceList: [],
            isLoading: false,
            storeServiceFilter: ModelKeywordFilter.data()
        }
    },
    mounted() {
        this.loadStoreServiceList();
    },
    methods: {
        openStoreServiceForm(key) {
            this.storeServiceKeyId = key;
            this.isShowStoreServiceForm = true;
        },
        closeStoreServiceForm(isReload) {
            this.isShowStoreServiceForm = false;

            if (isReload) {
                this.loadStoreServiceList();
            }
        },
        filterStoreServiceList(value) {
            this.storeServiceFilter = value;
            this.loadStoreServiceList();
        },
        filterResult(result) {
            if (this.storeServiceFilter.keyword) {
                result = result.filter(x => x.serviceTopic?.toLowerCase().indexOf(this.storeServiceFilter.keyword.toLowerCase()) > -1);
            }

            return result;
        },
        async loadStoreServiceList() {
            this.isLoading = true;
            this.storeServiceList = [];
            const result = await DBStoreService.get();

            if (result.content && result.content.length > 0) {
                // Filter Result
                result.content = this.filterResult(result.content);

                // Place into the Object
                this.storeServiceList = this.mapViewData(result.content);
            }

            this.isLoading = false;
        },
        mapViewData(content) {
            const data = [];

             content.forEach((item) => {
                data.push({
                    key: item.key,
                    serviceTopic: item.serviceTopic,
                    price: Helper.getCommaNumber(item.price),
                    data: item
                });
             });

            return data;
        },
        deleteStoreService(item) {
            this.$swal({
                title: 'ลบบริการของร้าน?',
                text: 'โปรดยืนยันว่าต้องการลบรายการบริการอันนี้',
                icon: 'question',
                showCancelButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const loader = this.$AppUtility.renderLoadBackdrop();

                    await DBStoreService.delete(item);

                    this.loadStoreServiceList();
                    loader.hide();
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
table {
    .small-column {
        width: 150px;
    }
}
</style>